import "isomorphic-fetch";

import { API_URL } from './constants'

const prognosis = {
    1: { id: 1, name: "Kommer bli underkänd", hsName: "Kommer bli underkänd", msName: "Kommer bli underkänd", score: 0, color: "#B60202", textColor: "white" },
    2: { id: 2, name: "Riskerar bli underkänd", hsName: "Riskerar bli underkänd", msName: "Riskerar bli underkänd", score: 0, color: "#FEE100", textColor: "#495057" },
    3: { id: 3, name: "Kommer nå lägst E högst D/C", msName: "Kommer nå lägst E högst C", hsName: "Kommer nå lägst E högst D", score: 10, color: "#8AC05D", textColor: "#495057" },
    4: { id: 4, name: "Kommer nå lägst C/B", msName: "Kommer nå lägst B", hsName: "Kommer nå lägst C", score: 17.5, color: "#539036", textColor: "white" },
    5: { id: 5, name: "Status okänd", msName: "Status okänd", hsName: "Status okänd", score: 0, color: "#ADD8E6", textColor: "white" },
}

export class Prognosis {

    static options = (isHighschool: boolean) => [
        { key: prognosis[1].id, value: prognosis[1][isHighschool ? 'hsName' : 'msName'], color: prognosis[1].color, textColor: prognosis[1].textColor },
        { key: prognosis[2].id, value: prognosis[2][isHighschool ? 'hsName' : 'msName'], color: prognosis[2].color, textColor: prognosis[2].textColor },
        { key: prognosis[3].id, value: prognosis[3][isHighschool ? 'hsName' : 'msName'], color: prognosis[3].color, textColor: prognosis[3].textColor },
        { key: prognosis[4].id, value: prognosis[4][isHighschool ? 'hsName' : 'msName'], color: prognosis[4].color, textColor: prognosis[4].textColor },
        { key: prognosis[5].id, value: prognosis[5][isHighschool ? 'hsName' : 'msName'], color: prognosis[5].color, textColor: prognosis[5].textColor }
    ];
    
    static defaultOptions = [
        { key: prognosis[1].id, value: prognosis[1].name, color: prognosis[1].color, textColor: prognosis[1].textColor },
        { key: prognosis[2].id, value: prognosis[2].name, color: prognosis[2].color, textColor: prognosis[2].textColor },
        { key: prognosis[3].id, value: prognosis[3].name, color: prognosis[3].color, textColor: prognosis[3].textColor },
        { key: prognosis[4].id, value: prognosis[4].name, color: prognosis[4].color, textColor: prognosis[4].textColor },
        { key: prognosis[5].id, value: prognosis[5].name, color: prognosis[5].color, textColor: prognosis[5].textColor }
    ];

    static enum : any = prognosis
}

const permissionTypes = {
    1: {
        id: 1,
        name: "Read",
        displayName: "Läsa"
    },
    2: {
        id: 2,
        name: "ReadWrite",
        displayName: "Läs och skriv"
    }
}

export class PermissionTypes {

    static enum = {
        [permissionTypes[1].id]: permissionTypes[1],
        [permissionTypes[2].id]: permissionTypes[2]
    }

    static options = [
        { key: permissionTypes[1].id, value: permissionTypes[1].displayName },
        { key: permissionTypes[2].id, value: permissionTypes[2].displayName }
    ]
}

export const UserDataForecastId = "forecast-filter"

export const graphQLPost = async function (query: string, variables?: object) {
    const body = JSON.stringify({query, variables: variables || {}});

    const promise = fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: body
    })
    .then(r => {
        if(r.redirected) {
            window.location.href = r.url;
        }
        const js = r.json();
        return js; 
    }).then(r => {
        if(r.errors)
            throw(r.errors.map((e: any, index: number) => ("Error " + (index + 1).toString() + ": " + e.message)).join(""));
        return r.data;
    })
    .catch(e => { 
        console.error(e);
        throw(e);
    })

    const response = await promise;

    return response;
}

export const delay = (ms : number) => new Promise(res => setTimeout(res, ms));

export const random = (min: number, max: number) => Math.random() * (max - min + 1) + min;
export const randomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1) + min);
export const tryParseInt = (str: string, defaultValue: number) => {
    const num = Number(str);

    if(!isNaN(num)) {
        return num;
    }
    else {
        return defaultValue;
    }
}

export const dateToString = (date: string) => { 
    return date.slice(0, 10); 
}

export const preventKeypressEnter = (event: React.KeyboardEvent<HTMLInputElement>, callback?: Function) : void => {
    if(event.key === 'Enter' && event.shiftKey == false) {
        event.preventDefault();
        if(callback != undefined) callback();
    }
}